import { ValueTransformer } from "@angular/compiler/src/util";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import * as moment from "moment";
import { NgxSpinnerService } from "ngx-spinner";
import { FileUpload } from "primeng/fileupload";
import { GLOBAL_CONSTANT } from "src/app/common/constant/global.constant";
import { locationBinderInterface } from "src/app/shared/component/location-binder/location-binder.interface";
import { SharedService } from "src/app/shared/service/api/shared.service";
import { UtilityService } from "src/app/shared/utility.service";
import * as _ from "underscore";

import { SessionService } from "../../../app/common/services/session.service";
import { environment } from "../../../environments/environment";
import { FILE_UPLOAD } from "../../common/constant/fileupload.constant";
import { GenericFormInterface } from "../generic.interface";
import { GenericService } from "../service/API/generic.service";
import { ChangeDetectorRef } from '@angular/core';

@Component({
  selector: "app-generic-visitor-form",
  templateUrl: "./generic-visitor-form.component.html",
  styleUrls: ["./generic-visitor-form.component.scss"],
})
export class GenericVisitorFormComponent implements OnInit {
  @Output() afterVoterAdd = new EventEmitter();
  @Output() isCancel = new EventEmitter();
  isEditable: boolean = false;
  @Input() editable;
  isReadOnly: boolean = false;

  _data: any ={
    extraFields: {},
    addressFields: {},
  };
  
  genderTypes: any;
  rationCardData: any;
  castData: any;
  subCastData: any;
  editableMode: boolean = false;
  voterData: any;
  officeId: any;
  netaFlag: boolean = false;
  userRole: any;
  yearRange: any;
  searchResultListConfig: any;
  totalRecords: any;
  educationTypes: any;
  selectedRationCard: string;
  voterFlag: boolean = false;
  //assembly, Gaon And Gat_number
  gaonData: Array<any>;
  prabhagAreaData: Array<any>;
  cityType: any;
  photo: any;
  selectedEducation: any;
  profilePhoto: any;
  isSearchVoter: boolean = false;
  bloodGroupType: any;
  selectedBloodGroup: any;
  locationBinderObj: locationBinderInterface;
  message: string;

  //File Upload
  uploadAPI = FILE_UPLOAD.Profile_image;
  @ViewChild("imageUpload", { static: false }) imageUpload: FileUpload;
  uploadedFiles = [];
  apiBaseUrl = environment.API_BASE;
  filetype = FILE_UPLOAD.File_type;
  picture: any;
  editableNumber: any;
  _entityName: string = "profileImage";
  previewImg: string = "assets/icons/userpro.png";
  hideInfoForm: boolean;
  @Input() showErrorMsg;
  @Input() showMandatoryMark;
  @Input() showMobileError;

  @Input()
  get selectedVisitor(): any {
    return this._data;
  }

  
  set selectedVisitor(value) {
    if (value) {
      // Safely parse addressFields
      if (typeof value.addressFields === 'string') {
        try {
          // Clean the string by removing excessive escape characters
          const cleanedStr = value.addressFields.replace(/\\+/g, '');
          value.addressFields = JSON.parse(cleanedStr);
        } catch (e) {
          console.error('Error parsing addressFields:', e);
          value.addressFields = {};
        }
      } else {
        value.addressFields = value.addressFields || {};
      }
  
      // Safely parse extraFields
      if (typeof value.extraFields === 'string') {
        try {
          const cleanedStr = value.extraFields.replace(/\\+/g, '');
          value.extraFields = JSON.parse(cleanedStr);
        } catch (e) {
          console.error('Error parsing extraFields:', e);
          value.extraFields = {};
        }
      } else {
        value.extraFields = value.extraFields || {};
      }
  
      this._data = {
        ...value,
        addressFields: value.addressFields,
        extraFields: value.extraFields
      };
    } else {
      this._data = {
        extraFields: {},
        addressFields: {},
      };
    }
    
    if (this._data.dob) {
      this._data.dob = this._data.dob ? new Date(this._data.dob) : null;
    }
    if (this._data.doe) {
      this._data.doe = this._data.doe ? new Date(this._data.doe) : null; 
    }
    if (this._data.education) {
      this.selectedEducation = _.find(this.educationTypes, (a) => {
        return a.value === this._data.education;
      });
    }
    if (this._data.bloodGroup) {
      this.selectedBloodGroup = this.bloodGroupType.find(
        (item) => item.value === this._data.bloodGroup
      );
    }
    if (this._data.rationCard) {
      this.selectedRationCard = _.find(this.rationCardData, (a) => {
        return a.value === this._data.rationCard;
      });
    }
    if (this._data.cast) {
      this.getCast();
    }
  }
  
  constructor(
    private service: SharedService,
    private sessionService: SessionService,
    private utilityService: UtilityService,
    private genericService: GenericService,
    private spinner: NgxSpinnerService,
    private cdRef: ChangeDetectorRef // Add this line
  ) {
    this.rationCardData = GLOBAL_CONSTANT.RATIONCARD_DATA;
    this.genderTypes = GLOBAL_CONSTANT.GENDER_TYPES;
    this.cityType = GLOBAL_CONSTANT.CITY_TYPES;
    this.educationTypes = GLOBAL_CONSTANT.EDUCATION_TYPE;
    this.bloodGroupType = GLOBAL_CONSTANT.BLOODGROUP_TYPE;
    this.yearRange = this.utilityService.CalYearRange();
    this._data = {
      extraFields: {},
      addressFields: {},
    };
    this.locationBinderObj = {};
  }

  calculateAge(dob) {
    if (this._data.dob != null) {
      dob = new Date(dob.model);
      if (dob != "Invalid Date") {
        this._data.age = moment().diff(dob, "years");
      }
      this._data.dob = new Date(
        Date.UTC(dob.getFullYear(), dob.getMonth(), dob.getDate())
      );
    } else {
      this._data.age = 0;
    }
  }

  getCast() {
    this.service.getCast().subscribe((res: any) => {
      this.castData = res;
      
      // After cast data is loaded, find and set the selected cast
      if (this._data.cast) {
        const foundCast = this.castData.find((cast: any) => cast.id == this._data.cast);
        if (foundCast) {
          this._data.cast = foundCast;
          this.getsubcastWithCast(this._data.cast.id);
        }
      }
    });
  }
  onChangeEducation(selectedEducation) {
    this._data.education = selectedEducation.value;
  }

  onChangeCast() {
    let selectedCastId = this._data.cast["id"];
    this.getsubcastWithCast(selectedCastId);
  }

  getsubcastWithCast(id: number) {
  const cast = this.castData.find((element: any) => element.id == id);
  if (cast) {
    this.subCastData = cast.subcast;
    
    // After subcast data is loaded, find and set the selected subcast
    if (this._data.subcast) {
      const foundSubcast = this.subCastData.find((subcast: any) => subcast.id == this._data.subcast);
      if (foundSubcast) {
        this._data.subcast = foundSubcast;
        this.cdRef.detectChanges(); // Trigger UI update
      }
    }
  }
}

  //Gaon List
  getGaonList(id) {
    this.service.getGaonDataWithAssembly(id).subscribe((res: any) => {
      this.gaonData = res[0];
    });
  }

  // prabhag area
  getPrabhagAreaList(id) {
    this.service.getPrabhagAreaData(id).subscribe((res: any) => {
      this.prabhagAreaData = res;
    });
  }

  //profile image
  saveProfile() {
    if (this.uploadedFiles.length >= 0) {
      this.imageUpload.upload();
    }
  }

  onUploadSuccess($event) {
    let d = $event.originalEvent.body.files;
    if (!this.editableMode) {
      this._data.ProfileImage = JSON.stringify(d);
    } else if (this.editableMode) {
      if (d && d.length != 0) {
        this._data.ProfileImage = JSON.stringify(d);
      } else {
        if (this.photo && this.photo != undefined) {
          this._data.ProfileImage = JSON.stringify(this.photo);
        } else {
          this._data.ProfileImage = JSON.stringify(d);
        }
      }
    }
  }

  // Check Existing Number
  checkExistingNo(obj) {
    let data = { phone: obj.target.value };
    if (data.phone !== this.editableNumber) {
      this.service.checkExistingNumber(data).subscribe(
        (res: any) => {},
        (err: any) => {
          this.message = err.error.message;
        }
      );
    } else {
    }
  }

  SaveData(voterData) {
    if (!voterData.valid) {
    } else {
      if (this.uploadedFiles.length >= 0) {
        this.imageUpload.upload();
      } else {
        this._data.ProfileImage = JSON.stringify(this._data.ProfileImage);
      }
    }
  }

  saveVoterData(voterForm) {
    if (!voterForm.valid) {
    } else {
      if (this.selectedEducation !== undefined) {
        this._data.education = this.selectedEducation.value;
      } else {
        this._data.education = null;
      }
      if (this.selectedBloodGroup != undefined) {
        this._data.bloodGroup = this.selectedBloodGroup.value;
      } else {
        this._data.bloodGroup = null;
      }
      if (this.selectedRationCard != undefined) {
        this._data.rationCard = this.selectedRationCard["value"];
      } else {
        this._data.rationCard = null;
      }

      if (this.locationBinderObj.cityType != undefined) {
        this.locationBinderObj.cityType = this.locationBinderObj.cityType[
          "value"
        ];
      } else {
        this.locationBinderObj.cityType = null;
      }
      
      if (this.editableMode) {
        this._data = Object.assign(this._data, this.locationBinderObj);
        this.genericService
          .updateGenericVisitor(this._data)
          .subscribe((res) => {
            this.afterVoterAdd.emit({ type: "SAVE", data: res });
          });
      } else {
        this._data = Object.assign(this._data, this.locationBinderObj);
        if (this.message != "EC009") {
          this.genericService.addGenericVisitor(this._data).subscribe((res) => {
            this.afterVoterAdd.emit({ type: "SAVE", data: res });
          });
        }
      }
    }
  }
  onCancel() {
    this.isCancel.emit({ isCancel: false });
  }
  onClear(voterForm){
    voterForm.reset();
    this.locationBinderObj ={};
  }
  searchVoter() {
    this.isSearchVoter = true;
  }
  closePopup() {
    this.isSearchVoter = false;
  }
  ngOnInit() {
    console.log('Initial _data:', this._data); // Debugging statement
    this._data.slnNumberInPart = this._data.slnNumberInPart || ''; // Initialize if null

    this.editableNumber = this._data.phone;
    this.spinner.hide();
    this.getCast();
    this.officeId = this.sessionService.getOffice();
    this.userRole = this.sessionService.getUserInfo().role;
    let vv = this.sessionService.isVirtualView();
    if (this.userRole == "VIEWER" || vv) {
      this.netaFlag = true;
    }
  }
}
